import React, { Component } from 'react';

import myHeader from './media/stb_booking.png'

export class NotInLine extends Component {
    static displayName = NotInLine.name;

    render() {
        return (
            <div className="form-signin shadow bg-home position-relative">
                <div className="head-nav p-0">
                    <img src={myHeader} alt="SBUX Partner Portal" className="img-fluid mt-0 mb-0" />
                </div>
                <div className="form-enter mt-0">
                    <div className="text-center">
                        <br /><br /><br /><br /><br />
                        <h3 className="pt-5 mt-5">Starbucks Community Room สามารถใช้งานได้ผ่านเบราว์เซอร์ภายในแอปพลิเคชัน LINE เท่านั้น</h3>
                   </div>
                </div>
            </div>

        );
    }
}